define('app/helpers/layer-helpers',['leaflet', 'app/helpers/map-helpers'], function(L, MapHelpers) {
  return {
    createWMSLayer: createWMSLayer,
    createAreaObject: createAreaObject,
    createPointObject: createPointObject,
    createLabelObject: createLabelObject,
  };

  function createWMSLayer(wmslayer, attribution, transparency, zIndex) {
    var layer = L.tileLayer.wms(wmslayer.baseurl, {
      layers: wmslayer.layer,
      format: 'image/png',
      transparent: true,
      attribution: attribution && MapHelpers.fromShowdownToHtml(attribution),
      styles: wmslayer.styles || '',
      opacity: MapHelpers.convertTransparencyToOpacity(transparency),
    });
    layer.setZIndex(zIndex || 200);
    return layer;
  }

  // Add Area to map
  function createAreaObject(geometry, obj) {
    var polygonStyle = {
      fill: true, // Needed to make area clickable
      fillColor: obj.fillcolor || '#555f5f',
      fillOpacity: obj.fillcolor ? 0.7 : 0.001,
      color: obj.color || '',
      weight: obj.color ? 3 : 0,
      'z-index': 200,
    };
    var area = L.geoJson(geometry, {
      // pane: paneId,
      style: polygonStyle,
      searchdata: obj.title,
    });
    // save style for calling resetStyle() later
    area.defaultOptions = { style: polygonStyle };

    var areaBounds = area.getBounds();
    if (areaBounds._northEast) {
      var marker = L.marker(areaBounds.getCenter(), {
        icon: L.divIcon({ className: 'mapifyer-label' }),
        title: obj.title,
        clickable: false,
      }).clearAllEventListeners();

      marker.tags = area.tags = obj.tags;
      marker.maxZoomLevel = obj.minZoomLevel;

      return area;
    }
  }

  function createPointObject(coords, obj, map) {
    var icon;
    if (window[obj.icon] != null) {
      // Get icon variable from havicons.js
      icon = window[obj.icon];
    }

    var paneId = MapHelpers.randomID();
    map.createPane(paneId);

    var mapWidth = map.getSize().x;
    var resizeFactor = 1;
    if (mapWidth <= 300) {
      resizeFactor = 0.5;
    } else if (mapWidth <= 500) {
      resizeFactor = 0.8;
    }
    var marker_width = 32;
    var marker_height = 48;

    var iconConfig = {
      iconUrl: window.havicon.url,
      iconSize: [marker_width * resizeFactor, marker_height * resizeFactor],
      iconAnchor: [15 * resizeFactor, 44 * resizeFactor],
      shadowSize: [44 * resizeFactor, marker_height * resizeFactor],
      shadowAnchor: [13 * resizeFactor, 44 * resizeFactor],
      popupAnchor: [1, -25 * resizeFactor],
    };

    var imageIcon = L.icon(iconConfig);

    if (icon && typeof icon === 'object') {
      iconConfig.iconUrl = icon.url;
      iconConfig.iconSize = [icon.width * resizeFactor, icon.height * resizeFactor];
      imageIcon = L.icon(iconConfig);
    } else if (obj.iconimageurl) {
      imageIcon = L.centeredIcon({ iconUrl: obj.iconimageurl, resizeFactor: resizeFactor });
    }

    var marker = L.marker(coords, {
      pane: paneId,
      opacity: 0.9,
      icon: imageIcon,
      searchdata: obj.title,
      maxZoomLevel: obj.minZoomLevel,
      infoText: obj.description,
      nonBubblingEvents: L.Marker.prototype.options.nonBubblingEvents.filter(function(value) {
        return value !== 'dblclick';
      }),
    });

    if (obj.prio) {
      map.getPane(paneId).style.zIndex = MapHelpers.calculateZIndex(obj.prio);
    }

    return marker;
  }

  // Add a label on the map (With a invisible marker)
  function createLabelObject(coords, obj, map, iconUrl) {
    var paneId = MapHelpers.randomID();
    map.createPane(paneId);

    var marker = L.marker(coords, {
      pane: paneId,
      opacity: 0.0, //opacity may be set to zero
      searchdata: obj.title,
      tags: obj.tags,
      point: 'marker',
      maxZoomLevel: obj.minZoomLevel,
      nonBubblingEvents: L.Marker.prototype.options.nonBubblingEvents.filter(function(value) {
        return value !== 'dblclick';
      }),
    });

    var sizeClass = 'normal';
    if (obj.size === 'Mindre') sizeClass = 'small';
    if (obj.size === 'Större') sizeClass = 'large';

    var hasDescription = obj.description && obj.description !== '';
    var cssClass = 'labels ' + sizeClass + (!hasDescription ? ' labels-no-tooltip' : '');

    marker.bindTooltip(obj.title, {
      pane: paneId,
      interactive: true,
      sticky: true,
      direction: 'center',
      permanent: true,
      className: cssClass,
      offset: [0, -8],
    });

    if (obj.prio) {
      map.getPane(paneId).style.zIndex = MapHelpers.calculateZIndex(obj.prio);
    }

    return marker;
  }
});

